<header (window:scroll)="windowScroll()" id="page-topbar">
  <div class="layout-width">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box horizontal-logo">
          <a class="logo logo-dark" href="index.html">
            <span class="logo-sm">
              <img alt="" height="22" src="assets/images/logo-light.svg">
            </span>
            <span class="logo-lg">
              <img alt="" height="32" src="assets/images/logo-light.svg">
            </span>
          </a>

          <a class="logo logo-light" href="index.html">
            <span class="logo-sm">
              <img alt="" height="22" src="assets/images/logo-dark.svg">
            </span>
            <span class="logo-lg">
              <img alt="" height="32" src="assets/images/logo-dark.svg">
            </span>
          </a>
        </div>

        <button (click)="toggleMobileMenu($event)" class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger "
                id="topnav-hamburger-icon" type="button">
          <span class="hamburger-icon">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>

        <!-- App Search-->
        <form class="app-search d-none d-md-block me-2">
          <div class="dropdown-menu dropdown-menu-lg" id="search-dropdown">
            <ngx-simplebar style="max-height: 320px;">
              <div>
                <div class="dropdown-header">
                  <h6 class="text-overflow text-muted mb-0 text-uppercase">Recent Searches</h6>
                </div>

                <div class="dropdown-item bg-transparent text-wrap">
                  <a class="btn btn-soft-secondary btn-sm btn-rounded" href="index.html">how to setup
                    <i class="mdi mdi-magnify ms-1"></i></a>
                  <a class="btn btn-soft-secondary btn-sm btn-rounded" href="index.html">buttons <i
                    class="mdi mdi-magnify ms-1"></i></a>
                </div>
                <div class="dropdown-header mt-2">
                  <h6 class="text-overflow text-muted mb-1 text-uppercase">Pages</h6>
                </div>

                <a class="dropdown-item notify-item" href="javascript:void(0);">
                  <i class="ri-bubble-chart-line align-middle fs-18 text-muted me-2"></i>
                  <span>Analytics Dashboard</span>
                </a>

                <a class="dropdown-item notify-item" href="javascript:void(0);">
                  <i class="ri-lifebuoy-line align-middle fs-18 text-muted me-2"></i>
                  <span>Help Center</span>
                </a>

                <a class="dropdown-item notify-item" href="javascript:void(0);">
                  <i class="ri-user-settings-line align-middle fs-18 text-muted me-2"></i>
                  <span>My account settings</span>
                </a>

                <div class="dropdown-header mt-2">
                  <h6 class="text-overflow text-muted mb-2 text-uppercase">Members</h6>
                </div>

                <div class="notification-list">
                  <a class="dropdown-item notify-item py-2" href="javascript:void(0);">
                    <div class="d-flex">
                      <img alt="user-pic"
                           class="me-3 rounded-circle avatar-xs" src="assets/images/users/avatar-2.jpg">
                      <div class="flex-1">
                        <h6 class="m-0">Angela Bernier</h6>
                        <span class="fs-11 mb-0 text-muted">Manager</span>
                      </div>
                    </div>
                  </a>
                  <a class="dropdown-item notify-item py-2" href="javascript:void(0);">
                    <div class="d-flex">
                      <img alt="user-pic"
                           class="me-3 rounded-circle avatar-xs" src="assets/images/users/avatar-3.jpg">
                      <div class="flex-1">
                        <h6 class="m-0">David Grasso</h6>
                        <span class="fs-11 mb-0 text-muted">Web Designer</span>
                      </div>
                    </div>
                  </a>
                  <a class="dropdown-item notify-item py-2" href="javascript:void(0);">
                    <div class="d-flex">
                      <img alt="user-pic"
                           class="me-3 rounded-circle avatar-xs" src="assets/images/users/avatar-5.jpg">
                      <div class="flex-1">
                        <h6 class="m-0">Mike Bunch</h6>
                        <span class="fs-11 mb-0 text-muted">React Developer</span>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </ngx-simplebar>

            <div class="text-center pt-3 pb-1">
              <a class="btn btn-primary btn-sm" href="#">View All Results <i
                class="ri-arrow-right-line ms-1"></i></a>
            </div>
          </div>
        </form>

      </div>

      <div class="d-flex align-items-center">

        <div class="dropdown d-md-none topbar-head-dropdown header-item" ngbDropdown>
          <button class="btn btn-icon btn-topbar btn-ghost-primary rounded-circle" ngbDropdownToggle
                  type="button">
            <i class="bx bx-search fs-22"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" ngbDropdownMenu>
            <form class="p-3">
              <div class="form-group m-0">
                <div class="input-group">
                  <input aria-label="Recipient's username" class="form-control" placeholder="Search ..."
                         type="text">
                  <button class="btn btn-primary" type="submit"><i
                    class="mdi mdi-magnify"></i></button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="dropdown ms-1 topbar-head-dropdown header-item" ngbDropdown>
          <button class="btn btn-icon btn-topbar btn-ghost-primary rounded-circle" ngbDropdownToggle
                  type="button">
            <img id="header-lang-img" src="{{flagvalue ?? valueset}}" alt="Header Language" height="20"
                 class="rounded"/>
          </button>
          <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
            @for (item of listLang; track $index) {
              <a href="javascript:void(0);" class="dropdown-item notify-item language py-2"
                 (click)="setLanguage(item.name, item.id, item.icon)" [title]="item.name">
                <img src="{{item.icon}}" alt="user-image" class="me-2 rounded-circle" height="18"/>
                <span class="align-middle">{{ item.name }}</span>
              </a>
            }
          </div>
        </div>

        <div class="ms-1 header-item d-none d-sm-flex">
          <button (click)="fullscreen()" class="btn btn-icon btn-topbar btn-ghost-primary rounded-circle"
                  type="button">
            <i class='las la-expand fs-24'></i>
          </button>
        </div>

        <div class="ms-1 header-item d-flex">
          <button (click)="modeChange()"
                  class="btn btn-icon btn-topbar btn-ghost-primary rounded-circle light-dark-mode"
                  type="button">
            <i class='las la-moon fs-24'></i>
          </button>
        </div>

        <notifications *ngCan="'notifications.unread'"/>

        <div class="dropdown header-item" ngbDropdown>
          <button class="btn d-flex align-items-center" id="page-header-user-dropdown" ngbDropdownToggle type="button">
            <span class="d-flex align-items-center">
              <ng-container *ngIf="photoThumb(); else placeholder">
                <img
                  [src]="photoThumb()"
                  alt="avatar"
                  width="128"
                  height="128"
                  class="rounded-circle header-profile-user"
                />
              </ng-container>

              <ng-template #placeholder>
                <i class="ri-user-line fs-1 text-secondary"></i>
              </ng-template>
              <span class="text-start ms-xl-2">
                <span class="d-none d-xl-inline-block fw-medium user-name-text fs-16">
                  {{ userData().firstName }}
                </span>
                <ng-container *ngIf="userData().company">
                  <br />
                  <small class="text-muted">{{ userData().company?.companyName }}</small>
                </ng-container>
              </span>
            </span>
          </button>

          <div class="dropdown-menu dropdown-menu-end p-0 overflow-hidden" ngbDropdownMenu>
            <!-- Profile Header -->
            <div class="p-3 bg-light border-bottom text-center d-flex flex-column align-items-center">
              <ng-container *ngIf="photoThumb(); else placeholderBig">
                <img
                  [src]="photoThumb()"
                  alt="avatar"
                  class="rounded-circle mb-2"
                  width="72"
                  height="72"
                />
              </ng-container>
              <ng-template #placeholderBig>
                <div class="d-flex align-items-center justify-content-center bg-secondary rounded-circle mb-2" style="width:72px; height:72px;">
                  <i class="ri-user-line fs-2 text-white"></i>
                </div>
              </ng-template>

              <h6 class="mb-0 fw-bold">{{ userData().firstName }} {{ userData().lastName }}</h6>
              <small class="text-muted d-block">{{ RoleIdLabels[RoleService.currentRole] | translate }}</small>
              <small class="text-muted d-block" *ngIf="userData().company">
                {{ userData().company?.companyName }}
              </small>
            </div>
            <div (click)="changeProfile()" class="dropdown-item text-dark cursor-pointer py-3 border-bottom">
              <i class="bx bx-user fs-15 align-middle me-1 text-dark"></i>
              <span>{{'USERS.CHANGE_PROFILE' | translate}}</span>
            </div>
            <div (click)="logout()" class="dropdown-item text-danger cursor-pointer py-3">
              <i class="bx bx-power-off fs-15 align-middle me-1 text-danger"></i>
              <span key="t-logout">{{'LOGOUT' | translate}}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</header>
